<template>
    <div class="row mx-0 media-gallery-wrapper" :class="{ 'single-media' : singleMedia }">
        <div v-if="fromCustomer && (submissionInfo && submissionInfo.votes)" class="item-label">
            <i class="ecom-favourite-full"/>
            {{ submissionInfo.votes }}
        </div>
        <MediaUploader :single-media="singleMedia" :is-video-uploader="videoUploadMode" :key="'pastime-media'+'-0'" :main-media="!singleMedia" :position="0"/>
        <MediaUploader v-if="!singleMedia" :key="'pastime-media'+'-1'" :position="1"/>
        <MediaUploader v-if="!singleMedia" class="m-0" :key="'pastime-media'+'-2'" :position="2"/>
        <MediaUploader v-if="!singleMedia" class="m-0" :key="'pastime-media'+'-3'" :position="3"/>
    </div>
</template>

<script>
import {store} from '@/store/pastimes';
import MediaUploader from '@/components/Pastimes/Desktop/partials/MediaUploader';
import {isEmpty} from 'lodash-es';

export default {
    store,
    name: 'MediaGallery',
    components: {
        MediaUploader
    },
    props: {},
    data() {
        return {}
    },
    computed: {
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        singleMedia() { 
            return this.pastimeInfo.detailedInfo.mediaLayoutSize == 1;
            //return false;
        },
        videoUploadMode() {
            // for now only one
            return this.singleMedia && this.pastimeInfo.baseInfo.layoutType == 'ONEVIDEO';
        },
        fromCustomer() {
            let registrationInfo = this.$store.getters['contestantPage/registrationInfo'];
            if(isEmpty(registrationInfo)) {
                return false;
            }
            return registrationInfo.fromCustomer;
        },
        submissionInfo() {
            return this.$store.getters['contestantPage/registrationInfo'];
        },
        activePage() {
            return this.$store.getters.activePage;
        },
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        method1() { }
    }
};
</script>

<style scoped>

</style>